/* eslint-disable */
import { produce } from "immer";
import {
  INVESTMENT_DATA_FETCH_FAILURE,
  INVESTMENT_DATA_FETCH_SUCCESS,
  INVESTMENT_DATA_FETCH_START,
} from "../actions/types";

const investments = (
  state = {
    investmentsFetching: false,
    investmentsData: [],
    investmentsError: null,
  },
  action,
) => {
  switch (action.type) {
    case INVESTMENT_DATA_FETCH_START:
      return produce(state, (draft) => {
        draft.investmentsFetching = true;
      });
    case INVESTMENT_DATA_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.investmentsFetching = true;
        draft.investmentsData = action.data;
        draft.investmentsFetching = false;
      });
    case INVESTMENT_DATA_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.investmentsFetching = false;
        draft.investmentsError = action.error;
      });
    default:
      return state;
  }
};

export default investments;
